import {AccessibilityErrorFilled} from "@fluentui/react-icons";
import {Column, Row} from "./Layout";
import {getCurrentSubDomain} from "../../HomePage";
import {Image} from "@fluentui/react-components";
import successIcon from "../../../assets/ver3/nbt/success.png"
import {useCommonPageStyles} from "../../../styles/mission/commonStyle";
import {useUserStore} from "../../../stores/useUserStore";
import {useEffect} from "react";


export default function FinishPage () {

    const currentSubDomain = getCurrentSubDomain();
    const style = useCommonPageStyles()

    const resetUserInfo = useUserStore(state => state.resetUserData)

    useEffect(()=>{
        resetUserInfo()
    },[])

    if(currentSubDomain === "nbt" || currentSubDomain.includes("toktokquiz") ){
        return <div className={style.nbt_root}>
            <Image alt={"success_icon"} src={successIcon}/>
            <div className={style.textStyle}>
                이미 미션 참여에 완료하셨습니다.<br/>
                앱을 통해 다시 접속해주시면 감사하겠습니다.
            </div>
        </div>
    }
    else {
        return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
            <div style={{height: '96px'}}/>
            <AccessibilityErrorFilled fontSize={'200px'}/>
            <Row>
                이미 미션 참여에 완료하셨습니다!
            </Row>
            <Row>
                앱을 통해 다시 접속해주시면 감사하겠습니다.
            </Row>
        </Column>
    }

}